import { render, staticRenderFns } from "./profit-table.vue?vue&type=template&id=28c3af4e"
import script from "./profit-table.vue?vue&type=script&lang=js"
export * from "./profit-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports